import { AfterViewInit, Component, ElementRef, Inject, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AddEditOTISLineAgentsComponent } from 'src/app/components/settings/otisline-agents/add-edit-otisline-agents/add-edit-otisline-agents.component';
import { Map, AuthenticationType, HtmlMarker } from 'azure-maps-control';
import { LocalDataService } from 'src/app/shared/services/local-data.service';

@Component({
  selector: 'app-phone-number-search',
  templateUrl: './phone-number-search.component.html',
  styleUrls: ['./phone-number-search.component.scss']
})
export class PhoneNumberSearchComponent implements AfterViewInit {
  constructor(public _dialogRef: MatDialogRef<AddEditOTISLineAgentsComponent>,
    @Inject(MAT_DIALOG_DATA) public _data: any, private _localDataService: LocalDataService) {

  }

  @ViewChild('phonenumbersearchmap', { static: true })
  public mapContainer!: ElementRef;

  ngAfterViewInit(): void {
    let latitude = this._data.latitude;
    let longitude = this._data.longitude;
    var map = new Map(this.mapContainer.nativeElement, {
      center: [longitude, latitude],
      zoom: 15,
      style: 'road',
      view: 'Auto',
      autoResize: true,
      language: 'en-US',
      authOptions: {
        authType: AuthenticationType.subscriptionKey,
        subscriptionKey: this._localDataService.getAzureMapKey()
      }
    });
    //Wait until the map resources are ready.
    map.events.add('ready', function () {
      //Create a HTML marker and add it to the map.
      map.markers.add(new HtmlMarker({
        htmlContent: `<style>
        .pin {
            width: 30px;
            height: 30px;
            border-radius: 50% 50% 50% 0;
            background: #00cae9;
            position: absolute;
            transform: rotate(-45deg);
            left: 50%;
            top: 50%;
            margin: -20px 0 0 -20px;
        }

        .pin:after {
            content: "";
            width: 14px;
            height: 14px;
            margin: 8px 0 0 8px;
            background: #e6e6e6;
            position: absolute;
            border-radius: 50%;
        }

        .bounce {
            animation-name: bounce;
            animation-fill-mode: both;
            animation-duration: 1s;
        }

        .pulse {
            background: #d6d4d4;
            border-radius: 50%;
            height: 14px;
            width: 14px;
            position: absolute;
            left: 50%;
            top: 50%;
            margin: 11px 0px 0px -12px;
            transform: rotateX(55deg);
            z-index: -2;
        }

        .pulse:after {
            content: "";
            border-radius: 50%;
            height: 40px;
            width: 40px;
            position: absolute;
            margin: -13px 0 0 -13px;
            animation: pulsate 1s ease-out;
            animation-iteration-count: infinite;
            opacity: 0;
            box-shadow: 0 0 1px 2px #00cae9;
            animation-delay: 1.1s;
        }

        @keyframes pulsate {
            0% {
                transform: scale(0.1, 0.1);
                opacity: 0;
            }

            50% {
                opacity: 1;
            }

            100% {
                transform: scale(1.2, 1.2);
                opacity: 0;
            }
        }

        @keyframes bounce {
            0% {
                opacity: 0;
                transform: translateY(-2000px) rotate(-45deg);
            }

            60% {
                opacity: 1;
                transform: translateY(30px) rotate(-45deg);
            }

            80% {
                transform: translateY(-10px) rotate(-45deg);
            }

            100% {
                transform: translateY(0) rotate(-45deg);
            }
        }
    </style>
    <div><div class='pin bounce'></div><div class='pulse'></div></div>`,
        position: [longitude, latitude],
        pixelOffset: [5, -18]
      }));
    });
  }
  onDialogCancel(): void {
    this._dialogRef.close();
  }
}
